import styled from "styled-components";

export const InputWrapper = styled.div`
  > div {
    width: 100%;
  }

  @media only screen and (max-width: 640px) {
    max-width: 245px !important;
  }
`;
